const { version } = require('../../package.json');
const FIREBASE = require('./config-fb-prod');

module.exports = {
  ENV: 'production',
  FIREBASE,
  BASE_API_URL: 'https://api.collarapp.uk',
  API_URL: 'https://api.collarapp.uk/graphql',
  SUB_API_URL: 'wss://api.collarapp.uk/graphql',
  MEET_URL: 'https://meet.collar.pet',
  CLIENT_ID: `WEB-${version}`,
  DYNAMIC_LINK_DOMAIN_PREFIX: 'https://collar.page.link',
  WEBSITE_PREFIX: 'https://collar.pet',
  BUGSNAG_KEY: 'bb7617aa0f3e7ecc53719ee7caf07d9d',
  GOOGLE_MAPS_API_KEY: 'AIzaSyCZC4rfyCcwVu0Wjp5Hx49_HhAmegEut90',
  BUNNY_API_KEY: '7a187e37-dad6-42b5-b88961ae4abe-ea5b-4980',
  BUNNY_LIBRARY_ID: '384511',
  BUNNY_IFRAME_EMBED: 'https://iframe.mediadelivery.net/embed',
  ROLLBAR_KEY: 'f07e6d8003704a7f816adc397933126d',
  ROLLBAR_ENV: 'production',
  CLARITY_PROJECT_ID: 'r8sp4944gb'
};
